import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { BookOpenIcon } from 'lucide-react';
interface ChapterItem {
  number: string;
  title: string;
}
const chapters: ChapterItem[] = [{
  number: '→',
  title: 'Introduction — The Veil of the Game'
}, {
  number: '01',
  title: 'The Mask of the Self'
}, {
  number: '02',
  title: 'The Soul as a Player'
}, {
  number: '03',
  title: 'The Origin and the Source'
}, {
  number: '04',
  title: 'The Mirage of Time'
}, {
  number: '05',
  title: 'The Characters of the Game'
}, {
  number: '06',
  title: 'The System and Its Rules'
}, {
  number: '07',
  title: 'Entities and Dimensions'
}, {
  number: '08',
  title: 'The Mirror of Relationships'
}, {
  number: '09',
  title: 'The Great Illusion'
}, {
  number: '10',
  title: 'Contracts and Ties'
}, {
  number: '11',
  title: 'The Secret of Fear'
}, {
  number: '12',
  title: 'The Art of Playing Awake'
}, {
  number: '13',
  title: 'The Language of Code: DMT and Simulated Reality'
}, {
  number: '∞',
  title: 'Epilogue — The Real Game'
}];
export function ChapterList() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="py-16 md:py-24 bg-gradient-to-b from-black via-neutral-950 to-black" data-id="element-148">
      <div className="max-w-4xl mx-auto px-6" data-id="element-149">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-150">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 text-xs font-semibold tracking-wider uppercase border rounded-full bg-teal-500/20 text-teal-400 border-teal-500/30 mb-6" data-id="element-151">
            <BookOpenIcon className="w-4 h-4" data-id="element-152" />
            13 Chapters
          </span>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-white" data-id="element-153">
            What You'll Find Inside
          </h2>
        </motion.div>

        {/* Chapter list */}
        <div className="space-y-2" data-id="element-154">
          {chapters.map((ch, i) => <motion.div key={ch.number + ch.title} initial={{
          opacity: 0,
          x: -16
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.4,
          delay: 0.05 * i
        }} className="flex items-center gap-4 md:gap-6 p-4 rounded-xl bg-neutral-900/40 border border-neutral-800/40 group" data-id="element-155">
              <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-teal-500/10 flex items-center justify-center" data-id="element-156">
                <span className="text-teal-400 text-sm font-mono font-bold" data-id="element-157">
                  {ch.number}
                </span>
              </div>
              <h3 className="font-serif text-base md:text-lg text-white font-medium" data-id="element-158">
                {ch.title}
              </h3>
            </motion.div>)}
        </div>
      </div>
    </section>;
}